import { useState } from "react";
import useHttp from "./useHttp";

const useSurvey = () => {
  const { HttpService } = useHttp();

  const [loadings, setLoadings] = useState({
    getSurveys: false,
  });

  const [surveyData, setSurveyData] = useState(null);

  const getSurveys = async () => {
    try {
      setLoadings({ ...loadings, getSurveys: true });
      const response = await HttpService.get("/api/v1.1/survey_result");
      setLoadings({ ...loadings, getSurveys: false });
      setSurveyData(response.data.data);
    } catch ({ err, response }) {
      setLoadings({ ...loadings, getSurveys: false });
    }
  };

  const exports = { getSurveys, surveyData, loadings };
  return exports;
};

export default useSurvey;
